import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';
interface SsoNonceResponse {
    nonce: string;
    expires_in: number;
    enterprise_org_id?: string;
    enterprise_network_id?: string;
}

@Injectable({ providedIn: 'root' })
export class SsoService {
  constructor(
    private http: HttpClient,
    private sanitizer: DomSanitizer
  ) { }

  getNonce(requireEnterpriseOrgId = false): Observable<SsoNonceResponse> {
    const body = requireEnterpriseOrgId ? { require_enterprise_org_id: true } : {};
    return this.http.post<SsoNonceResponse>(`${environment.apiBaseUrl}/sso/nonce`, body);
  }

  /**
   * Constructs the enterprise portal SSO URL, optionally with a redirect path.
   * @param targetPath - Path to redirect to after authentication (e.g. '/services').
   * @returns Sanitized URL.
   */
  buildIframeUrl(targetPath = ''): SafeResourceUrl {
    const base = `${environment.enterprisePortalUrl}/sso`;
    const url = targetPath ? `${base}?redirect=${encodeURIComponent(targetPath)}` : base;
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  /**
   * Extracts the origin from the enterprise portal URL for postMessage validation.
   * @returns The origin string.
   */
  getEnterpriseOrigin(): string {
    try {
      const url = new URL(environment.enterprisePortalUrl);
      return url.origin;
    } catch (e) {
      return '';
    }
  }
}
